import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectPolygonFeatures } from '@redux/situation/situation.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { Layer, Source } from 'react-map-gl/mapbox';

import { SourceNameEnum } from '@/types/map.types';

import { polygonLocationLayer, polygonLocationOutlineLayer, polygonTrajectoryOutlineLayer } from './polygon.layer';

function PolygonLayer() {
  const polygonFeatures = useSelectorWithReplayMode(selectPolygonFeatures);

  if (!isFeatureCollection(polygonFeatures)) return null;

  return (
    <Source id={SourceNameEnum.POLYGONS} type="geojson" data={polygonFeatures}>
      <Layer {...polygonTrajectoryOutlineLayer} />
      <Layer {...polygonLocationLayer} />
      <Layer {...polygonLocationOutlineLayer} />
    </Source>
  );
}

export default PolygonLayer;
